define('plugin/back-to-site/model/BackToSiteModel',['require','lib/model/BaseModel'],function (require) {

    var BaseModel = require('lib/model/BaseModel');

    /**
     * Back to site model
     *
     * @class BackToSiteModel
     */
    return BaseModel.extend({

        url: '/ext/back-to-site/',

        defaults: {
            title: '',
            link: '',
            mobile_title: '',
            mobile_link: '',
            timer_title: '',
            timer_enabled: false,
            timeout: 10
        }

    });

});
